<template>
  <app-page :head="data.head" :body="data.body" />
</template>

<script setup>
definePageMeta({
  middleware(to, from) {
    to.meta.pageTransition = to.name != from.name;
  },
});

const route = useRoute();
const { data } = await useFetch(
  `/api/page_findproduct?lng=${route.params.locale}`
);

const { loadItems, updateResults } = useFilters();

const { offset: _offset, ...query } = route.query;
const LIMIT = 60;
const searchProduct = await loadItems(
  route.query.keyword ? "/api/search-product" : "/api/filters",
  {
    ...query,
    offset: 0,
  },
  route.query.offset ? parseInt(route.query.offset) + LIMIT : LIMIT
);
updateResults(searchProduct);
</script>
